<template>
  <div class="tab-pane active" id="dtab1" role="tabpanel">
    <h3>Wetter <a href="#" class="wetterlink">wetter.com</a></h3>
    <p class="mb-1 font12 float-left"><b>Aktuelle Wetterdaten:</b></p>
    <button type="button" class="btn btn-light float-right"><i class="fa fa-check-square-o" aria-hidden="true"></i>
      Speichern </button>

    <div class="clearfix">wetter.com</div>
    <div class="mb-5 mt-3">
      <div class="row">
        <div class="col-md-2">Land:</div>
        <div class="col-md-10">Deutschland</div>
        <div class="col-md-2">PLZ:</div>
        <div class="col-md-10">40545</div>
        <div class="col-md-2">Ort:</div>
        <div class="col-md-10">Oberkassel (Düsseldorf)</div>
      </div>
    </div>
    <h3>Aktuelles Layout als Vorlage abspeichern</h3>

    <button type="button" class="btn btn-light"> Wetterdaten laden </button>

  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/WeatherTab.vue